import { createContext, useContext } from "react";
import React from 'react'
const AppContext = createContext();



const AppProvider = ({ children }) => {

 const name="Isha"
    return (
        <AppContext.Provider value={{name}}>
            {children}
        </AppContext.Provider>
    )
}

const useDataContext=()=>{
    return useContext(AppContext)
}
export {AppContext,AppProvider,useDataContext}